module.exports = __webpack_public_path__ + "img/1995FirstAmendmentFloorPlan_1.6ae3011d.png";